import React from 'react'
import {StyledButton, Spinner} from './Button.styles'
import {PlanArrowIcon} from '../icons'

/**
 * Button
 *
 * @param {'primary'|'secondary'|'solid'|'danger'} variant
 *   - primary   : blue brand button
 *   - secondary : white with border
 *   - solid     : full black — used for modal footer buttons
 *   - danger    : red destructive action
 *
 * @param {'sm'|'md'|'lg'} size
 * @param {boolean} isLoading  - shows spinner, disables button
 * @param {boolean} fullWidth  - stretches to fill container width
 */
export function Button({
  variant = 'primary',
  size = 'sm',
  isLoading = false,
  fullWidth = false,
  disabled = false,
  leftIcon,
  children,
  ...props
}) {
  return (
    <StyledButton
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled || isLoading}
      aria-busy={isLoading}
      {...props}
    >
      {isLoading && <Spinner aria-hidden="true" />}
      {leftIcon ?? (variant === 'action-orange' ? <PlanArrowIcon /> : null)}
      {children}
    </StyledButton>
  )
}
